import React, { Component } from "react";
import firebase from "../../firebase";
import Button from "@material-ui/core/Button";

class Images extends Component {
  state = {
    galleryHasImages: false,
    galleryImages: [],
    uploadedImg: false,
    imgName: "",
    imgDetails: "",
    image: {},
    imgUrl: "",
    open: false,
    imageId: null
  };

  componentDidMount() {
    let ref = firebase.database().ref("images");
    ref.on("value", snap => {
      let val = snap.val();
      if (val !== null) {
        this.setState({ galleryHasImages: true, galleryImages: val });
      }
    });
    window.addEventListener("keydown", this.handleClose);
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref()
      .off();
  }

  handleOpen = id => {
    this.setState({ open: true, imageId: id });
  };

  handleClose = e => {
    if (e.keyCode === 27) {
      this.setState({ open: false });
    }
  };

  handleClickClose = e => {
    this.setState({ open: false });
  };

  handleImage = e => {
    let { files } = e.target;
    let file = files[0];
    let size = `${file.size / 1000}KB`;
    let fName = file.name;
    let type = file.type;
    this.setState({ imgName: fName, uploadedImg: true, image: file }, () => {
      let reader = new FileReader();
      reader.onload = e => {
        let img = document.querySelector("#previewImg");
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
    this.setState({
      imgDetails: `Size: ${size}, Name: ${fName}, Type: ${type}`
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    let gallery = firebase.storage().ref(`/images/${this.state.imgName}`);
    gallery.put(this.state.image).then(snapshot => {
      snapshot.ref.getDownloadURL().then(url => {
        let name = this.state.imgName;
        if (this.state.galleryHasImages) {
          let currentImages = this.state.galleryImages;
          currentImages.push({ file: name, URL: url });
          let tempArr = currentImages;
          firebase
            .database()
            .ref()
            .update({ images: tempArr });
          this.setState({ uploadedImg: false });
        } else {
          firebase
            .database()
            .ref()
            .update({ images: [{ file: name, URL: url }] });
          this.setState({ uploadedImg: false });
        }
      });
    });
  };

  deleteImage = id => {
    this.setState({ open: false }, () => {
      let image = id;
      let ref = firebase.database().ref(`images/${image}`);
      ref
        .remove()
        .then(e =>
          console.log(`Successfully removed the image from the database.`)
        );

      let fileName = this.state.galleryImages[id].file;
      let gallery = firebase.storage().ref(`/images/${fileName}`);
      gallery
        .delete()
        .then(() => console.log("Successfully removed image from storage."))
        .catch(e => console.log(`failed to remove: ${e}`));
    });
  };

  render() {
    let emptyGallery = (
      <div className="empty-gallery-upload">
        <h2 className="empty-gallery-title">
          Your gallery appears to be empty, try uploading an image!
        </h2>
        <label htmlFor="image">
          Upload Image <i className="fas fa-cloud-upload-alt" />
        </label>
        <input
          type="file"
          id="image"
          name="image"
          accept=".jpg, .png, .jpeg"
          onChange={this.handleImage}
        />
        <br />

        {this.state.uploadedImg ? (
          <div className="img-preview">
            <img id="previewImg" src="" alt={this.state.imgName} />
            <p>{this.state.imgDetails}</p>
            <input
              type="submit"
              id="submit"
              name="submit"
              value="Upload Selected Image"
              onClick={this.handleSubmit}
            />
          </div>
        ) : null}
      </div>
    );

    let gallery = this.state.galleryHasImages ? (
      <div className="gallery-images">
        {this.state.galleryImages.map((el, id) => (
          <div className="gallery-image-parent" key={id}>
            <img
              className="single-image"
              src={el.URL}
              alt={el.file}
              onClick={() => this.handleOpen(id)}
            />
            {this.state.open ? (
              <div className="image-modal-container">
                <div id="close-modal" onClick={this.handleClickClose}>
                  <span>X</span>
                </div>
                <div className="image-modal-content container">
                  <div className="col-xs-12 col-sm-6 col-lg-8">
                    <img
                      src={this.state.galleryImages[this.state.imageId].URL}
                      alt="modal view"
                      className="modal-image"
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-lg-4">
                    <div className="single-image-name">
                      <h2>Photo name:</h2>
                      <p>{this.state.galleryImages[this.state.imageId].file}</p>
                    </div>
                    <div className="single-image-url">
                      <h2>Photo URL:</h2>
                      <a
                        href={this.state.galleryImages[this.state.imageId].URL}
                        target="_blank"
                      >
                        {this.state.galleryImages[this.state.imageId].URL}
                      </a>
                    </div>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => this.deleteImage(this.state.imageId)}
                    >
                      Permentantly remove image
                    </Button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    ) : null;

    let existingGallery = (
      <div className="populated-gallery-upload">
        <h2 className="populated-gallery-title">Upload an Image</h2>
        <label htmlFor="image">
          Upload Image <i className="fas fa-cloud-upload-alt" />
        </label>
        <input
          type="file"
          id="image"
          name="image"
          accept=".jpg, .png, .jpeg"
          onChange={this.handleImage}
        />
        <br />

        {this.state.uploadedImg ? (
          <div className="img-preview">
            <img id="previewImg" src="" alt={this.state.imgName} />
            <p>{this.state.imgDetails}</p>
            <input
              type="submit"
              id="submit"
              name="submit"
              value="Upload Selected Image"
              onClick={this.handleSubmit}
            />
          </div>
        ) : null}
      </div>
    );

    return (
      <section className="gallery-section" onKeyPress={this.handleClose}>
        {this.state.galleryHasImages ? null : emptyGallery}
        <div className="gallery-page-content">
          <div
            className={
              this.state.galleryHasImages ? "gallery-container-main" : null
            }
          >
            {gallery}
          </div>
          {this.state.galleryHasImages ? (
            <div className="gallery-add-img-sidebar">{existingGallery}</div>
          ) : null}
        </div>
      </section>
    );
  }
}

export default Images;



// WEBPACK FOOTER //
// ./src/admin/pages/Images.js